import { TextArea } from "atoms/TextArea";

export interface TextAreaStepProps {
  title: string;
  label: string;
  name: string;
  value: string;
  onChange: (key: string, value: string | string[]) => void;
  error?: boolean;
}
export const TextAreaStep = (props: TextAreaStepProps) => {
  const hasError = !!props.error;
  return (
    <div>
      <p className="pb-8 font-serif text-h3">{props.title}</p>

      <TextArea
        key={props.name}
        label={props.label}
        value={props.value}
        onChange={(value) => props.onChange(props.name, value)}
        invalid={hasError}
      />
    </div>
  );
};
